export default class BookletSkills {
  constructor() {
    this.bindEvents();
    // Initialize the image upload component
    this.initCommentImageHandling();
    this.initImageZoom();
  }

  bindEvents() {
    document.querySelectorAll('.skill-note-button').forEach((button) => {
      button.addEventListener('click', () => {
        const status = button.getAttribute('data-status');
        const skillItem = button.closest('.skill-item');
        const noteId = skillItem.getAttribute('data-note-id');
        const customerId = skillItem.getAttribute('data-customer-id');

        // Désactiver tous les boutons du même skill-item
        skillItem.querySelectorAll('.skill-note-button').forEach((btn) => {
          btn.classList.add('readonly');
          btn.style.pointerEvents = 'none';
        });

        fetch(`/monitor/students/${customerId}/booklet/skills/${noteId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify({ note: status })
        }).then(response => response.json()).then(data => {
          if (data.success) {
            skillItem.querySelectorAll('.skill-note-button').forEach((btn) => {
              btn.classList.remove('selected');
            });
            button.classList.add('selected');
          }
        }).finally(() => {
          // Réactiver tous les boutons du même skill-item
          skillItem.querySelectorAll('.skill-note-button').forEach((btn) => {
            btn.classList.remove('readonly');
            btn.style.pointerEvents = 'auto';
          });
        });
      });
    });
  }

  // Use the ImageHandler utility instead of implementing the image handling here
  initCommentImageHandling() {
    // Import the ImageHandler utility
    import('../utils/ImageHandler').then(module => {
      const ImageHandler = module.default;
      // Create an instance of the image handler utility
      this.imageHandler = new ImageHandler();
      // Initialize all image handling functionality
      this.imageHandler.initializeImageHandling();
    });
  }

  initImageZoom() {
    // Import the ImageZoom utility
    import('../utils/ImageZoom').then(module => {
      const ImageZoom = module.default;
      // Create an instance of the image zoom utility
      this.imageZoom = new ImageZoom();
    });
  }
}